import {Pipe, PipeTransform} from '@angular/core';

declare var moment: any;

@Pipe({name: 'isoToSimpleDate'})
export class ISOToDateSimplePipe implements PipeTransform {

  constructor() {
  }

  transform(value: string): string {

    let date;
    value = value.toString();
    if (!Number.parseInt(value) || value.indexOf('T') >= 0) {
      date = moment(value)._d;
    } else {
      date = moment.unix(value)._d;
      if (date.getFullYear() > 3000) {
        date = moment.unix(Number.parseInt(value) / 1000)._d;
      }
    }

    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    let year = date.getFullYear();

    const resultDate = day + '-' + month + '-' + year;
    return resultDate;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/iso-to-simpledate.pipe.ts